import React from 'react'
import './ArticlesCard.css'
import Zoom from 'react-reveal/Zoom';
export default function ArticlesCard({card}) {

    const redirectToArticle =(link)=> {

        window.open(link);

    }

    return (
        <Zoom>
        <div className="articles-card" style={{backgroundImage: `url(${card.background})`}} onClick={()=>redirectToArticle(card.link)}>
            
            <div className="article-card-title">
            <h5>{card.title}</h5>
            <h6> {card.title !== "See More ..." ? "Click to read article" : "Click to see my blog"}</h6>
            </div>
        </div>
        </Zoom>
    )
}
